import {
	KnowledgeDiscoveryJiraSearchClassification,
	type KnowledgeDiscoveryJiraIntentDetectionModelType,
	type KnowledgeDiscoveryJiraSearchClassificationType,
} from '@atlassian/search-client';

import { disposableValue } from './disposable-value';

export const IntentMode: {
	readonly GNIN: 'GNIN';
	readonly FPS: 'FPS';
} = KnowledgeDiscoveryJiraSearchClassification;

export type IntentMode = KnowledgeDiscoveryJiraSearchClassificationType;

export type IntentDetection = {
	mode: IntentMode;
	query: string;
	route: string;
	modelId: KnowledgeDiscoveryJiraIntentDetectionModelType;
};

export const INTENT_DETECTION: import('./disposable-value').DisposableValue<IntentDetection | null> =
	disposableValue<IntentDetection | null>(null);
